export default __webpack_public_path__ + "static/media/news4.172ed1ed.png";